module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"teamName":"Nom d\u0027équipe","teamScore":"Points","checkinStatus":"Checkin Effectué ?","checkinOK":"OK"},"en":{"teamName":"Team Name","teamScore":"Score","checkinStatus":"Checkin Done ?","checkinOK":"OK"}}')
  delete Component.options._Ctor
}
